const FakeFileUploader = (props) => <div className='component-uploader__image-wrapper' style={{
  width: props.width,
  display: props.hidden ? 'none' : 'block'
}}>
  <div style={{ paddingBottom: `${props.height / props.width * 100}%` }}>
    <label className={'component-uploader__style'}>
      <div className={'component-uploader__no-image'}>
        <span className={'label-with-icon'}>
          <i className={'icon icon-camera component-uploader__icon-camera'} />
          Click to add
        </span>
      </div>
      {props.children}
    </label>
  </div>
</div>

export default FakeFileUploader
